<template>
    <span :style="{color}" class="dots"/>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#000'
        }
    }
};
</script>


<style lang="scss" scoped>
.dots {
    position: absolute;
    width: 10px;
    height: 10px;
    background-image: radial-gradient(currentColor 22%, transparent 23%),
        radial-gradient(currentColor 22%, transparent 23%);
    background-size: 9px 9px;
    background-position: 0 0, 0px 0px;
}
</style>
